import { Modal as MagneticModal, ModalProps } from "@magnetic/modal";

interface Props extends ModalProps {}

export const Modal = (props: Props) => {
  return <MagneticModal {...props} />;
};
